import { RouteType } from '@/lib/route';
import PreviewReview from '@/pages/PreviewReview';
import { PreviewLivePath } from '@/pages/PreviewLive/consts';

const PreviewLiveRoutes: RouteType = {
  path: PreviewLivePath,
  component: PreviewReview,
};

export default PreviewLiveRoutes;
